/**
 * Toggle sidebar content on mobile
 */

const MOBILE_WIDTH = 767;
const $sidebarContent = $('.sidebar__content');
const $sidebarMobile = $('.js-mobile-sidebar');
const $sidebarLocation = $('.js-sidebar-location')

/**
 * Slide toggle sidebar content on mobile
 *
 * @return {Void}
 */
$('.js-sidebar').on('click', '.sidebar__head', function(evt) {
	if (deviceIsMobile()) {
		evt.preventDefault();

		$sidebarContent
			.slideToggle()
			.parent()
			.toggleClass('is-active');
	}
});


/**
 * Fix styles on resize from smaller to bigger screen
 *
 * @return {Void}
 */

$(window).on('resize', function(evt) {
	evt.preventDefault();

	if (!deviceIsMobile()) {
		$sidebarContent.removeAttr('style');
	}
});


/**
 * Clone sidebar content into another location
 */
$(document).ready(() => {
	$sidebarLocation.append($sidebarMobile.html());
});

/**
 * Check if user is on mobile
 * @return {Number}
 */
const deviceIsMobile = () => $(window).outerWidth() <= MOBILE_WIDTH;
